import WebApp from '@twa-dev/sdk';

const API_BASE = (import.meta as ImportMeta & { env?: { VITE_API_BASE?: string } }).env?.VITE_API_BASE
  ?? 'https://agentbridge-telegram-gateway-xdenubho5a-du.a.run.app';

export interface MeResponse {
  ok: boolean;
  chatId: number;
  orgId: string;
  role: 'owner' | 'member';
  i18n: 'ko' | 'en';
  onboarding?: { completed: boolean; currentStep: number; answers: Record<string, string> } | null;
  fitnessProfile?: {
    goal?: string;
    level?: string;
    currentPhase?: number;
    competitionDate?: string;
    competitionLabel?: string;
  } | null;
  notificationSchedule?: { workoutTimes?: string[]; types?: string[] } | null;
  personaPreferences?: { tone?: string; motivationLevel?: string; responseStyle?: string } | null;
  error?: string;
}

function getChatId(): number | null {
  const id = WebApp.initDataUnsafe.user?.id;
  return typeof id === 'number' ? id : null;
}

/**
 * Telegram WebApp initData가 있으면 X-Init-Data 헤더 (HMAC 검증).
 * 없으면 (브라우저 단독 테스트 등) chat_id query fallback.
 */
function authHeaders(): HeadersInit {
  const initData = WebApp.initData;
  return initData ? { 'X-Init-Data': initData } : {};
}

function authQuery(): string {
  // initData가 있을 땐 backend가 헤더 우선이므로 query 무관, 단 fallback 시점 위해 chat_id 항상 동봉
  const chatId = getChatId();
  return chatId ? `chat_id=${chatId}` : '';
}

export async function fetchMe(): Promise<MeResponse | null> {
  try {
    const res = await fetch(`${API_BASE}/api/me?${authQuery()}`, {
      headers: authHeaders(),
    });
    if (!res.ok) {
      console.warn('[fetchMe failed]', res.status);
      return null;
    }
    return (await res.json()) as MeResponse;
  } catch (err) {
    console.error('[fetchMe error]', err);
    return null;
  }
}

export interface SkillVideo {
  title: string;
  url: string;
  duration?: string;
  videoId?: string;
  thumbnailUrl?: string;
}

export interface SkillResponse {
  ok: boolean;
  text?: string;
  buttons?: Array<Array<{ text: string; callback_data?: string; web_app?: { url: string } }>>;
  videos?: SkillVideo[];
  error?: string;
}

export async function fetchSkill(name: string): Promise<SkillResponse | null> {
  try {
    const res = await fetch(`${API_BASE}/api/skill/${name}?${authQuery()}`, {
      headers: authHeaders(),
    });
    return (await res.json()) as SkillResponse;
  } catch (err) {
    console.error(`[fetchSkill ${name} error]`, err);
    return null;
  }
}

export async function recordPR(exercise: string, weight: number, reps: number): Promise<boolean> {
  try {
    const res = await fetch(`${API_BASE}/api/pr?${authQuery()}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...authHeaders() },
      body: JSON.stringify({ exercise, weight, reps }),
    });
    return res.ok;
  } catch (err) {
    console.error('[recordPR error]', err);
    return false;
  }
}
